<app-modal-add-provider [type_info]="type_info" [provider_info]="provider_info"></app-modal-add-provider>
